module.exports = __webpack_public_path__ + "fonts/AkkuratLL-LightItalic.578196b4.otf";